<template>
  <base-dialog v-bind="$attrs" width="600px" @handleClose="handleClose"
               @handleConfirm="handleConfirm" :show-close="false">
    <template #title>{{title!==''?$t('memoryBankV2.upload'):$t('common.import')}}</template>
    <div class="upload-file-title">
      {{$t('memoryBankV2.corpusFile')}}
    </div>
    <el-upload ref="upload" class="corpus-upload" drag action :limit="20"
               :on-progress="uploadFileProcess" :show-file-list="false" :accept='accept'
               :on-exceed="handleExceed" :http-request="uploadSectionFile"
               :before-upload="beforeUploadFile" :file-list="fileList" :on-change="uploadChange"
               multiple>
      <div class="upload-empty" v-show="!fileList.length">
        <div class="file-tips-text">
          {{bankType==='memory'?$t('memoryBankV2.uploadFormat'):$t('termBankV2.uploadFormat')}}
        </div>
      </div>

      <el-table v-show="fileList.length" :data="fileList" style="width: 100%" border height="100%"
                header-cell-class-name="header-cell-class-name" cell-class-name="cell-class-name">
        <!-- <el-table-column width="55" type="index" :index="indexMethod"
                         :label="$t('termBankV2.number')" align="center" /> -->

        <el-table-column prop="name" :label="$t('projectDetailsV2.file')+$t('newProjectV2.name')"
                         show-overflow-tooltip align="center" />
        <el-table-column prop="uppercaseSuffix" width="100"
                         :label="$t('projectDetailsV2.file')+$t('project.format')" align="center"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="80">
          <template slot-scope="{$index}">
            <div class="table-icon-warp">
              <el-tooltip :content="$t('common.del')" effect="dark" placement="top-start">
                <div class="table-icon-warp_item icon-delete" @click.stop="handleDelete($index)">
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="name" :label="$t('termBankV2.name')" min-width="100"
                         show-overflow-tooltip align="center" /> -->
      </el-table>
    </el-upload>
  </base-dialog>
</template>

<script>
import { getUploadSign } from "@/services/newProjectApi";
import {
  addMemory,
  addTransTerm,

} from "@/services/memoryBank";
import axios from "axios";
export default {
  name: 'CorpusDetailUploadDialog',
  props: {
    corpusDetailInfo: {
      type: Object,
      default: () => { }
    },
    bankType: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ""
    },
    uploadType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // 用于接收文件
      fileList: [],
      // 签名返回的数据
      uploadSignInfo: {},
      // 最后得到的文件上传地址的集合
      sentFileUrlList: [],
    }
  },
  computed: {
    // 限制类型的集合
    validationTypeList() {
      const arr = this.accept.split(',')
      const formatArr = arr.map(item => item.split('.')[1])
      return formatArr
    },
    // 检测文件编码时传入的url 
    fileUrl() {
      return this.bankType === 'memory' ? '/api/v1/memory/checkFileContent' : '/api/v1/term/checkFileContent'
    }
  },
  methods: {
    // 表格序号
    indexMethod(index) {
      let i = index + 1
      return i < 10 ? `0${i}` : i;
    },
    // 删除已经上传的文件
    handleDelete($index) {
      this.fileList.splice($index, 1)
      this.sentFileUrlList.splice($index, 1)
    },
    // 上传之前的验证
    beforeUploadFile(file) {
      const type = file.name.split('.')[file.name.split('.').length - 1]
      const isLt20M = file.size / 1024 / 1024 < 20;
      const isRepeatName = this.fileList.slice(0, -1).some(item => {
        return item.name === file.name
      })
      if (this.bankType === 'memory') {
        if (!this.validationTypeList.includes(type)) {
          this.$message.closeAll()
          this.$message({
            message: this.$t("memoryBankV2.supportedFormatsText"),
            type: "warning"
          })
          return false
        }
      } else {
        if (!this.validationTypeList.includes(type)) {
          this.$message.closeAll()
          this.$message({
            message: this.$t("termBankV2.supportedFormatsText"),
            type: "warning"
          })
          return false
        }
      }
      if (isRepeatName) {
        this.fileList.pop()
        this.$message({
          message: this.$t("termBankV2.uploadFileRepeat") + "!",
          type: "warning"
        })
        return false
      }
      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: this.$t("termBankV2.uploadFileContentEmpty"),
          type: "warning"
        });
        return false;
      }
      if (!isLt20M) {
        this.$message.closeAll();
        this.$message({
          message: this.$t("termBankV2.uploadFileSize", [20]),
          type: "warning"
        });
        file.obp = false;
        return false;
      }
      return true
    },
    //文件上传过程中的函数(在这里获取进度条的进度)
    uploadFileProcess(event, file, fileList) {
      fileList.forEach(item => {
        if (parseInt(item.percentage) !== 100) {
          item.progressPercent = Math.abs(item.percentage.toFixed(0));
        }
      })
    },

    // 获取上传签名
    async getUploadSign() {
      const { success, result } = await getUploadSign()
      if (!success) return
      this.uploadSignInfo = result
    },

    getFileHost(param, formData) {
      const self = this
      let config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios.post(self.uploadSignInfo.host, formData, config)
        .then(({ data, status }) => {
          if (status !== 200 || !data.success) return
          const { result } = data
          self.getFileContent(result.fileName, param);
        })
    },

    // 检测文件编码
    async getFileContent(path, param) {
      const uid = param.file.uid
      const { success, result } = await this.catReq1Service(this.fileUrl, {
        fileUrlList: [path]
      })
      if (!success) return
      const { status, reason: message } = result
      if (!status) {
        this.$message.closeAll();
        this.$message({
          message,
          type: "error"
        });
      }
      this.fileList.forEach(item => {
        if (item.uid === uid) {
          if (!status) {
            item.percentage = -1
          } else {
            this.sentFileUrlList.push(path)
          }
        }
      })
      this.fileList = this.fileList.filter(item => item.percentage !== -1)
    },

    // 自定义上传
    async uploadSectionFile(param) {
      await this.getUploadSign()
      const file = param.file
      const type = file.name.split('.')[file.name.split('.').length - 1]
      const { keyPrefix, sign, token, ts } = this.uploadSignInfo
      const formDataParams = {
        key: `${keyPrefix}.${type}`,
        file: param.file,
        sign,
        token,
        ts
      }
      const formData = new FormData()
      Object.keys(formDataParams).forEach(key => {
        formData.append(key, formDataParams[key])
      })
      this.getFileHost(param, formData)
    },

    uploadChange(event, file) {
      this.fileList = file
      this.fileList.forEach(item => {
        const uppercaseSuffix = item.name.split('.')[item.name.split('.').length - 1].toUpperCase()
        this.$set(item, 'uppercaseSuffix', uppercaseSuffix)
      })
    },

    // 超出上传文件数量触发
    handleExceed() {
      this.$message({
        message: this.$t("common.uploadMaxNum"),
        type: "warning"
      })
    },

    handleClose() {
      this.$emit('handleClose');
      this.fileList = []
      this.sentFileUrlList = []
      this.uploadSignInfo = {}
    },
    async handleConfirm() {
      if (this.fileList.length !== this.sentFileUrlList.length) {
        this.$message.closeAll()
        this.$message({
          message: this.$t('termBankV2.fileProcessing'),
          type: "warning"
        });
        return
      }
      if (this.sentFileUrlList.length < 1) {
        this.$message.warning(this.$t('newProjectV2.uploadFileTip'));
        return;
      }
      const { targetLang, sourceLang, domainCode, id, name, domain, langDesc } = this.corpusDetailInfo
      let params = {};
      if (this.uploadType === 'project') {
        params = {
          domainName: domain,
          langDesc,
          name,
          targetLang,
          sourceLang,
          domainCode,
          sentFileUrlList: this.sentFileUrlList
        }
      } else {
        params = {
          id,
          targetLang,
          sourceLang,
          domainCode,
          sentFileUrlList: this.sentFileUrlList
        }
      }
      const fn = this.bankType === 'memory' ? addMemory : addTransTerm
      const { success } = await fn(params)
      if (!success) return
      this.$emit('handleConfirm');
      this.fileList = []
      this.sentFileUrlList = []
      this.uploadSignInfo = {}
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 0 60px;
  .upload-file-title {
    margin-bottom: 8px;
    text-align: left;
    color: #303133;
  }
  .corpus-upload {
    margin-bottom: 22px;
    width: 100%;
    .el-upload {
      width: 100%;
    }
    .el-upload-dragger {
      width: 100%;
      height: 166px;
      border: 1px solid #d9d9d9;
      &:hover {
        border-color: #0078fc;
      }
      .upload-empty {
        position: relative;
        width: 100%;
        height: 100%;
        background: #fbfcfd url("../images/corpus-detail-upload.png") no-repeat
          center 20px;
      }
      .file-tips-text {
        padding: 0 20px;
        box-sizing: border-box;
        position: absolute;
        bottom: 18px;
        left: 0;
        width: 100%;
        font-size: 12px;
        color: #909399;
        text-align: center;
        word-break: break-word;
      }
      .el-table {
        .gutter {
          background: #f2f3f5;
        }
        .header-cell-class-name,
        .cell-class-name {
          padding: 4px 0;
          color: #707070;
        }
        .header-cell-class-name {
          background: #f2f3f5;
        }
        .table-icon-warp {
          display: flex;
          align-items: center;
          justify-content: center;
          .table-icon-warp_item + .table-icon-warp_item {
            margin-left: 16px;
          }
          &_item {
            width: 20px;
            height: 20px;
            cursor: pointer;
            background-position: center center;
            background-repeat: no-repeat;
          }
          .icon-delete {
            background-image: url("../images/deleter.png");
            &:hover {
              background-image: url("../images/deleter_pre.png");
            }
          }
        }
      }
    }
    // margin: 25px 0 24px 0;
  }
}
</style>